import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import ResidencyPermitForm from './form';
import {
  NewPersonVM,
  AccordionResidencyPermit,
} from 'shell/components/shared/sipo-person-form/new-person';

const ResidencyPermitComponent = (): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldResidencyPermitChange = useEventCallback(
    (
      key: keyof AccordionResidencyPermit,
      value: AccordionResidencyPermit[keyof AccordionResidencyPermit]
    ) => {
      formContext.setFieldValue('residencyPermit', {
        ...formContext.values.residencyPermit,
        [key]: value,
      });
    }
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-permit-residency-content"
        id="panel-permit-residency-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Permesso di soggiorno</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ResidencyPermitForm
          values={formContext.values.residencyPermit}
          onChange={onFieldResidencyPermitChange}
          errors={formContext.errors.residencyPermit as FormikErrors<AccordionResidencyPermit>}
          touched={
            formContext.touched
              .residencyPermit as unknown as FormikTouched<AccordionResidencyPermit>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

ResidencyPermitComponent.displayName = 'Accordion Residency Permit component';

const ResidencyPermit = memo(ResidencyPermitComponent);

export default ResidencyPermit;
